var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.035 33.883c0 1.12-.913 2.03-2.038 2.03a2.035 2.035 0 01-2.038-2.03c0-1.12.913-2.03 2.038-2.03 1.125 0 2.038.91 2.038 2.03zm-1.02-4.059h-2.037l-1.02-10.146h4.077l-1.02 10.146zM23.998 9.653L40.914 39.97H7.08L23.997 9.653zm0-3.653a.61.61 0 00-.488.361L4.104 41.107c-.265.487 0 .893.53.893h38.725c.571 0 .795-.406.53-.893L24.486 6.365A.613.613 0 0023.999 6h-.002z",
    fill: "#1998D5"
  })));
}
export default SvgWarningBlue;